function AirplaneIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg className="icon-airplane" viewBox="0 0 24 24" {...props}>
      <path
        d="M19 11.9l2.7 1.14c.18.08.3.26.3.46v2a.5.5 0 01-.6.49L12 14l-9.4 2a.5.5 0 01-.6-.49v-2c0-.2.12-.38.3-.46L5 11.9V10a1 1 0 112 0v1.06l4.8-2.02a.5.5 0 01.4 0l4.8 2.02V10a1 1 0 012 0v1.9z"
        className="secondary"
      />
      <path
        d="M12 2a2 2 0 012 2v8l-1 8h-2l-1-8V4c0-1.1.9-2 2-2z"
        className="primary"
      />
      <path
        d="M8.64 22.98c-.32.1-.64-.17-.64-.54v-1.1c0-.19.08-.35.2-.46l3.5-2.78a.51.51 0 01.6 0l3.5 2.78c.12.1.2.27.2.45v1.11c0 .37-.32.64-.64.54L12 21.9l-3.36 1.07z"
        className="secondary"
      />
    </svg>
  );
}

export default AirplaneIcon;
